import React from 'react';

import TabbedPane from '../../../components/plain/TabbedPane';
import FieldEnum from '../../../components/plain/FieldEnum';
import FieldString from '../../../components/plain/FieldString';
import FieldDate from '../../../components/plain/FieldDate';
import FieldInteger from '../../../components/plain/FieldInteger';
import FieldDatetime from '../../../components/plain/FieldDatetime';
import FieldCheckBox from '../../../components/plain/FieldCheckBox';
import FieldList_TableGroup from '../../../components/plain/FieldList_TableGroup';
import FieldList_CardsPanel from '../../../components/plain/FieldList_CardsPanel';
import FieldList_Strings from '../../../components/plain/FieldList_Strings';
import DivLocationList from './DivLocationList';
import DivConfirmationList from './DivConfirmationList';

import { getCurrentResource, formatDateTime } from '../../../util/tools';
import { getLanguage, isUserSuperUser, hasAccess } from '../../../util/localStorage';
import { performApiRequest, ACTION_YOUCONTROL_GET_PERSON_INFO_LOCAL_API_URL,
	ACTION_YOUCONTROL_GET_EMLOYEE_QTY_LOCAL_API_URL 
} from '../../../util/restapi';

class DivOrganization extends React.Component {
	
	/*
		fieldGroup
		readOnly
		plain
		instance
	*/
	constructor(props) {
		super(props);
	}
	
	createTab = (tabId) => {
		let parentField = this.props.fieldGroup;
		let readOnly = this.props.readOnly;
		let plain = this.props.plain;
		let instance = this.props.instance;
		if( tabId == 'names' )
			return <TabNames instance={instance} parentField={parentField} plain={plain} readOnly={readOnly} />;
		if( tabId == 'communications' )
			return <TabCommunications instance={instance} parentField={parentField} plain={plain} readOnly={readOnly} />;
		if( tabId == 'accounts' )
			return <TabAccounts instance={instance} parentField={parentField} plain={plain} readOnly={readOnly} />;
		if( tabId == 'contacts' )
			return <TabContacts instance={instance} parentField={parentField} plain={plain} readOnly={readOnly} />;
		if( tabId == 'locations' )
			return (
				<div style={{padding: '5px'}}>
					<DivLocationList path={'locations'} instance={instance} plain={plain} parentField={parentField} 
						readOnly={readOnly} ignoreTitle={true}
					/>
				</div>
			);
		if( tabId == 'confirmations' )
			return (
				<div style={{padding: '5px'}}>
					<DivConfirmationList path={'confirmations'} instance={instance} plain={plain} parentField={parentField} 
						readOnly={readOnly} ignoreTitle={true}
					/>
				</div>
			);
		if( tabId == 'youscore' )
			return <TabYouScore instance={instance} parentField={parentField} plain={plain} readOnly={true} div={this} />;
			
		return null;
	}
	
	refreshYouScore = async () => {
		let instance = this.props.instance;
		let fieldGroup = this.props.fieldGroup;
		let fieldCode = instance.getField('code', fieldGroup);
		let code = fieldCode.value;
		let request = {
			code: code
		}
		let response = await performApiRequest( ACTION_YOUCONTROL_GET_PERSON_INFO_LOCAL_API_URL, request );
		if( ! response.success ) {
			this.props.plain.props.app.showResponse( response, 'You control error' );
			return;
		}
		let personInfo = JSON.parse( response.jsonInfo );
		console.log( 'Person info', personInfo );
		response = await performApiRequest( ACTION_YOUCONTROL_GET_EMLOYEE_QTY_LOCAL_API_URL, request );
		if( ! response.success ) {
			this.props.plain.props.app.showResponse( response, 'You control error' );
			return;
		}
		let emplQty = JSON.parse( response.jsonInfo );
		console.log( 'Employee qty', emplQty );

		let fieldYouScore = instance.getField('urControlData', fieldGroup);
		instance.setFieldValueByPath('renewalTime', formatDateTime( new Date() ), fieldYouScore);
		instance.setFieldValueByPath('status', personInfo.status, fieldYouScore);
		if( personInfo.name ) {
			instance.setFieldValueByPath('fullName', personInfo.name.fullName, fieldYouScore);
			instance.setFieldValueByPath('shortName', personInfo.name.shortName, fieldYouScore);
		}
		if( personInfo.nameInEnglish ) {
			instance.setFieldValueByPath('engName', personInfo.nameInEnglish.fullName, fieldYouScore);
		}	

		let regDate = null;
		if( regDate === null ) {
			if( personInfo.registrationAfterLaw ) {
				regDate = personInfo.registrationAfterLaw.entryDate
			}
		}
		if( ! regDate ) {
			if( personInfo.registrationBeforeLaw ) {
				regDate = personInfo.registrationBeforeLaw.date
			}
		}
		if( ! regDate ) {
			if( personInfo.registrationViaReformation )
				regDate = personInfo.registrationViaReformation.date;
		}			
		if( regDate )
			instance.setFieldValueByPath('regDate', regDate, fieldYouScore);
			
		instance.setFieldValueByPath('lastDate', personInfo.actualDate, fieldYouScore);
		// kved
		if( personInfo.foundingCapital ) {
			instance.setFieldValueByPath('capital', personInfo.foundingCapital.sum, fieldYouScore);
		}
		
		if( emplQty && emplQty.length > 0 ) {
			instance.setFieldValueByPath('employeeQty', emplQty[0].max, fieldYouScore);
			
		}
		
		let head = '';
		if( personInfo.signers ) {
			for(let s of personInfo.signers) {
				if( s.role === 'керівник' ) {
					head = s.name;
					break;
				}
			}
		}
		instance.setFieldValueByPath('head', head, fieldYouScore);
		
		let fieldFounders = instance.getField('founder', fieldYouScore);
		let fieldOwners = instance.getField('owner', fieldYouScore);
		instance.clearField( fieldFounders );
		instance.clearField( fieldOwners );
		if( personInfo.founders ) {
			for(let f of personInfo.founders) {
				if( f.type == 0 ) { // Founder
					let item = instance.addListItem(fieldFounders, null, false);
					item.value = f.name;
				} else {
					let item = instance.addListItem(fieldOwners, null, false);
					item.value = f.name;
				}  
			}
		}
		
		let fieldKved = instance.getField('kved', fieldYouScore);
		instance.clearField( fieldKved );
		let kvedMainCode = '';
		if( personInfo.mainEconomicActivity ) {
			let item = instance.addListItem(fieldKved, null, false);
			instance.setFieldValueByPath('code', personInfo.mainEconomicActivity.code, item);
			instance.setFieldValueByPath('description', personInfo.mainEconomicActivity.description, item);
			kvedMainCode = personInfo.mainEconomicActivity.code;
		}
		if( personInfo.economicActivities ) {
			for(let ea of personInfo.economicActivities) {
				if( ea.code == kvedMainCode )
					continue;
				let item = instance.addListItem(fieldKved, null, false);
				instance.setFieldValueByPath('code', ea.code, item);
				instance.setFieldValueByPath('description', ea.description, item);
			}
		}
	}
	
	render() {
		let fieldGroup = this.props.fieldGroup;
		let readOnly=this.props.readOnly;
		let plain = this.props.plain;
		let instance = this.props.instance;
		let readOnlyFormAndCode = readOnly || ( ! isUserSuperUser() && instance.id )
		let tabs = [
			{
				rowId: 'first',
				tabs: [
					{ tabId: 'names', tabTitle: 'Назви', },
					{ tabId: 'communications', tabTitle: 'Комунікації', },
					{ tabId: 'accounts', tabTitle: 'Банківські рахунки', },
					{ tabId: 'contacts', tabTitle: 'Контакти', },
					{ tabId: 'locations', tabTitle: 'Локації', },
					{ tabId: 'confirmations', tabTitle: 'Супровідні документи', },
				]
			},
		];
		if( hasAccess('acc_you_control') ) { 
			tabs[0].tabs.push({tabId: 'youscore', tabTitle: 'YouControl'});
		}
		return (
			<div>
				<div style={{display: 'flex', alignItems: 'center', marginBottom: '15px'}}>
					<FieldEnum instance={instance} path={'orgType'} plain={plain} parentField={fieldGroup} 
						readOnly={readOnlyFormAndCode} 
						styles={{ select: {flexGrow: '1', marginRight: '20px'}}} 
					/>
					<FieldString instance={instance} path={'code'} plain={plain} parentField={fieldGroup} 
						readOnly={readOnlyFormAndCode}
						styles={{ input: {width: '150px', flexGrow: '1', marginRight: '20px'} }}
					/>
					<FieldString instance={instance} path={'nickName'} plain={plain} parentField={fieldGroup} readOnly={readOnly}
						styles={{ input: {width: '150px', flexGrow: '1'} }}
					/>
				</div>
				<div style={{display: 'flex', alignItems: 'center', marginBottom: '15px'}}>
					<FieldString instance={instance} path={'taxType'} plain={plain} parentField={fieldGroup} readOnly={readOnly}
						styles={{ input: {width: '100px', flexGrow: '1', marginRight: '20px'} }}
					/>
					<FieldString instance={instance} path={'taxNum'} plain={plain} parentField={fieldGroup} readOnly={readOnly}
						styles={{ input: {width: '100px', flexGrow: '1', marginRight: '20px'} }}
					/>
					<FieldString instance={instance} path={'taxCert'} plain={plain} parentField={fieldGroup} readOnly={readOnly}
						styles={{ input: {width: '100px', flexGrow: '1'} }}
					/>
				</div>
				{/*
				<div style={{display: 'flex', alignItems: 'center', marginBottom: '15px'}}>
					<FieldString instance={instance} path={'web'} plain={plain} parentField={fieldGroup} readOnly={readOnly}
						styles={{ divMain: {flexGrow: '1'} }}
					/>
				</div>
				*/}
				<div style={{display: 'flex', alignItems: 'center', marginBottom: '15px'}}>
					<FieldString instance={instance} path={'comment'} plain={plain} parentField={fieldGroup} readOnly={readOnly}
						styles={{ input: {flexGrow: '1'} }}
					/>
				</div>
				<TabbedPane tabs={tabs} createTab={this.createTab} 
					styles={{ divMain: {border: '1px solid gray', marginBottom: '5px'} }} 
				/>
			</div>
		);
	}
}

class TabNames extends React.Component {
	
	render() {
		let parentField = this.props.parentField;
		let readOnly = this.props.readOnly;
		let plain = this.props.plain;
		let instance = this.props.instance;
		return (
			<div style={{padding: '5px' }}>
				<FieldList_TableGroup instance={instance} path={'names'} plain={plain} parentField={parentField} readOnly={readOnly}
					plainDirtyCounter={plain.state.plainDirtyCounter} ignoreTitle={true}
					table={{
						columns: [
							{ columnId: 'language', styles: {tdHeader: {width: '20%'}} }, 
							{ columnId: 'name', styles: {tdHeader: {width: '50%'}} },
							{ columnId: 'shortName', styles: {tdHeader: {width: '30%'}} },
						],
					}}
					styles={{
						divMain: {marginBottom: '5px'},
						table: {width: '100%'},
						trHeader: {height: '43px'}
					}}
				/>
			</div>
		);
	}
}

class TabCommunications extends React.Component {
	
	render() {
		let parentField = this.props.parentField;
		let readOnly = this.props.readOnly;
		let plain = this.props.plain;
		let instance = this.props.instance;
		return (
			<div style={{padding: '5px' }}>
				<FieldList_TableGroup instance={instance} path={'communications'} plain={plain} parentField={parentField} readOnly={readOnly}
					plainDirtyCounter={plain.state.plainDirtyCounter} ignoreTitle={true}
					table={{
						columns: [
							{ columnId: 'type', styles: {tdHeader: {width: '15%'}} }, 
							{ columnId: 'value', styles: {tdHeader: {width: '35%'}} },
							{ columnId: 'notes', styles: {tdHeader: {width: '50%'}} },
						],
					}}
					styles={{
						divMain: {marginBottom: '5px'},
						table: {width: '100%'},
						trHeader: {height: '43px'}
					}}
				/>
			</div>
		);
	}
}

class TabAccounts extends React.Component {
	
	render() {
		let parentField = this.props.parentField;
		let readOnly = this.props.readOnly;
		let plain = this.props.plain;
		let instance = this.props.instance;
		return (
			<div style={{padding: '5px' }}>
				<FieldList_TableGroup instance={instance} path={'accounts'} plain={plain} parentField={parentField} readOnly={readOnly}
					plainDirtyCounter={plain.state.plainDirtyCounter} ignoreTitle={false}
					readOnly={readOnly} 
					table={{
						columns: [
							{ columnId: 'type', styles: {tdHeader: {width: '15%'}} }, 
							{ columnId: 'number', styles: {tdHeader: {width: '35%'}} },
							{ columnId: 'notes', styles: {tdHeader: {width: '50%'}} },
						],
					}}
					styles={{
						divMain: {marginBottom: '5px'},
						table: {width: '100%'},
						trHeader: {height: '43px'}
					}}
				/>
			</div>
		);
	}
}

class TabContacts extends React.Component {

	contactCardBuilder = (fieldContact, index) => {
		let card = '';
		let currentLanguage = getLanguage();
		let name = null;
		for(let n of fieldContact.value.names.value) {
			if( n.value.language.value == currentLanguage ) {
				name = n;
				break;
			}
		}
		if( name == null && fieldContact.value.names.value.length > 0)
			name = fieldContact.value.names.value[0];
		if( name != null ) {
			if( name.value.keyName.value )
				card += name.value.keyName.value + ' ';
			if( name.value.name.value )
				card += name.value.name.value + ' ';
			if( name.value.secondName.value )
				card += name.value.secondName.value + ' ';
		} 
		if( fieldContact.value.position.value )
			card += ' - ' + fieldContact.value.position.value;

		return card;
	}
	buildContactPanel = (fieldGroup, listItemInfo) => {
		let plain = this.props.plain;
		let instance = this.props.instance;
		let readOnly=this.props.readOnly;
		return (
			<ContactPanel fieldGroup={fieldGroup} listItemInfo={listItemInfo} 
				instance={instance} plain={plain} readOnly={readOnly}
			/>
		);
	}
	
	render() {
		let parentField = this.props.parentField;
		let readOnly=this.props.readOnly;
		let plain = this.props.plain;
		let instance = this.props.instance;
		return (
			<div style={{padding: '5px' }}>
				<FieldList_CardsPanel path={'contacts'} instance={instance} plain={plain} parentField={parentField} readOnly={readOnly} 
					buildItemComponent={this.buildContactPanel} itemCardBuilder={this.contactCardBuilder} 
					labelEmptyToHeader={true} readOnly={readOnly} ignoreTitle={true}
					styles={{
						divMain: {
							padding: '5px',
							backgroundColor: 'rgb(200,200,200)',
							border: '1px solid blue',
						},
						divCardsBlock: {
							backgroundColor: 'rgb(200,200,200)',
							minWidth: '300px'
						},
						divCard: {
							marginTop: '3px',
							padding: '7px',
							cursor: 'pointer',
							backgroundColor: 'rgb(230,230,230)',
							minHeight: '18px'
						}
					}}
				/>
			</div>
		);
	}
}

class TabYouScore extends React.Component {
	
	render() {
		let divOrganization = this.props.div;
		let parentField = this.props.parentField;
		let readOnly=this.props.readOnly;
		let plain = this.props.plain;
		let instance = this.props.instance;
		let fieldYouScore = instance.getField('urControlData', parentField);

		let fieldGroup = this.props.fieldGroup;
		let fieldCode = instance.getField('code', fieldGroup);
		let codeEDRPOU = fieldCode.value;
		let disableRefresh = true;
		if( codeEDRPOU )
			disableRefresh = false;
			
		return (
			<div style={{padding: '5px' }}>
				<div style={{display: 'flex', alignItems: 'center', marginBottom: '15px'}}>
					<button type='button' disabled={disableRefresh} style={{marginRight: '10px'}} onClick={divOrganization.refreshYouScore}>Оновити</button>
					<FieldDatetime instance={instance} path={'renewalTime'} plain={plain} parentField={fieldYouScore} 
						readOnly={readOnly}
						styles={{ input: {width: '250px', marginRight: '20px'} }}
					/>
					<FieldString instance={instance} path={'status'} plain={plain} parentField={fieldYouScore} 
						readOnly={readOnly}
						styles={{ input: {flexGrow: '1'} }}
					/>
				</div>
				<div style={{display: 'flex', alignItems: 'center', marginBottom: '15px'}}>
					<FieldString instance={instance} path={'fullName'} plain={plain} parentField={fieldYouScore} 
						readOnly={readOnly}
						styles={{ input: {width: '250px', flexGrow: '1'} }}
					/>
				</div>
				<div style={{display: 'flex', alignItems: 'center', marginBottom: '15px'}}>
					<FieldString instance={instance} path={'engName'} plain={plain} parentField={fieldYouScore} 
						readOnly={readOnly}
						styles={{ input: {width: '250px', flexGrow: '1'} }}
					/>
				</div>
				<div style={{display: 'flex', alignItems: 'center', marginBottom: '15px'}}>
					<FieldString instance={instance} path={'shortName'} plain={plain} parentField={fieldYouScore} 
						readOnly={readOnly}
						styles={{ input: {width: '400px', flexGrow: '1', marginRight: '20px'} }}
					/>
					<FieldString instance={instance} path={'regDate'} plain={plain} parentField={fieldYouScore} 
						readOnly={readOnly}
						styles={{ input: {width: '100px', flexGrow: '1', marginRight: '20px'} }}
					/>
					<FieldString instance={instance} path={'lastDate'} plain={plain} parentField={fieldYouScore} 
						readOnly={readOnly}
						styles={{ input: {width: '100px', flexGrow: '1'} }}
					/>
				</div>
				<div style={{display: 'flex', alignItems: 'center', marginBottom: '15px'}}>
					<FieldString instance={instance} path={'head'} plain={plain} parentField={fieldYouScore} 
						readOnly={readOnly}
						styles={{ input: {width: '150px', flexGrow: '1', marginRight: '20px'} }}
					/>
					<FieldInteger instance={instance} path={'capital'} plain={plain} parentField={fieldYouScore}
						styles={{ input: {flexGrow: '0', width: '200px', marginRight: '20px'} }} readOnly={readOnly}
					/>
					<FieldInteger instance={instance} path={'employeeQty'} plain={plain} parentField={fieldYouScore}
						styles={{ input: {flexGrow: '0', width: '200px'} }} readOnly={readOnly}
					/>
				</div>
				<div style={{display: 'flex', alignItems: 'top', marginBottom: '15px'}}>
					<FieldList_Strings instance={instance} path={'founder'} parentField={fieldYouScore} plain={plain} 
						readOnly={readOnly} disableAddItems={true} disableMoveItems={true} disableDeleteItems={true}
						styles={{ divMain: {flexGrow: '1', marginRight: '20px'} }}
					/>

					<FieldList_Strings instance={instance} path={'owner'} parentField={fieldYouScore} plain={plain} 
						readOnly={readOnly} disableAddItems={true} disableMoveItems={true} disableDeleteItems={true}
						styles={{ divMain: {flexGrow: '1', marginRight: '20px'} }}
					/>
					
					<FieldList_TableGroup instance={instance} path={'kved'} plain={plain} parentField={fieldYouScore} 
						readOnly={readOnly} disableAddItems={true} disableMoveItems={true} disableDeleteItems={true}
						table={{
							columns: [
								{ columnId: 'code', styles: {tdHeader: {width: '12%'}} },
								{ columnId: 'description', styles: {tdHeader: {width: '88%'} } },
							],
						}}
						styles={{
							divMain: {flexGrow: '1', },
							table: {width: '100%'},
							trHeader: {height: '33px'}
						}}
					/>
				</div>
			</div>
		);
	}
}

class ContactPanel extends React.Component {

	/*
		plain
		instance
		fieldGroup
		listItemInfo
		readOnly
	*/
	constructor(props) {
		super(props);
	}

	render() {
		let readOnly=this.props.readOnly;
		let fieldGroup = this.props.fieldGroup;
		let plain = this.props.plain;
		let instance = this.props.instance;
		return (
			<div style={{flexGrow: '1', margin: '5px 0 0 0', padding: '5px', backgroundColor: 'rgb(240,240,240)'}}>
				<div style={{padding: '5px', border: '1px solid gray'}}>
					<div style={{display: 'flex', alignItems: 'center', marginBottom: '15px'}}>
						<FieldCheckBox instance={instance} path={'founder'} plain={plain} parentField={fieldGroup} 
							styles={{divMain: {marginRight: '10px'} }} readOnly={readOnly}
						/>
						<FieldEnum instance={instance} path={'status'} plain={plain} parentField={fieldGroup} 
							readOnly={readOnly} 
							styles={{ select: {flexGrow: '1', marginRight: '10px'}}} 
						/>
						<FieldString instance={instance} path={'position'} plain={plain} parentField={fieldGroup}
							styles={{ input: {width: '150px', flexGrow: '0', marginRight: '10px'} }} readOnly={readOnly}
						/>
						<FieldDate instance={instance} path={'birthday'} plain={plain} parentField={fieldGroup}
							styles={{ input: {flexGrow: '0'} }} readOnly={readOnly}
						/>
					</div>
					<FieldList_TableGroup instance={instance} path={'names'} plain={plain} parentField={fieldGroup} readOnly={readOnly}
						plainDirtyCounter={plain.state.plainDirtyCounter} ignoreTitle={false}
						table={{
							columns: [
								{ columnId: 'language', styles: {tdHeader: {width: '22%'}} }, 
								{ columnId: 'keyName', styles: {tdHeader: {width: '26%'}} },
								{ columnId: 'name', styles: {tdHeader: {width: '26%'}} },
								{ columnId: 'secondName', styles: {tdHeader: {width: '26%'}} },
							],
						}}
						styles={{
							divMain: {marginBottom: '5px'},
							table: {width: '100%'},
							trHeader: {height: '43px'}
						}}
					/>
					<FieldList_TableGroup instance={instance} path={'communications'} plain={plain} parentField={fieldGroup} readOnly={readOnly}
						plainDirtyCounter={plain.state.plainDirtyCounter} ignoreTitle={false}
						table={{
							columns: [
								{ columnId: 'type', styles: {tdHeader: {width: '20%'}} }, 
								{ columnId: 'value', styles: {tdHeader: {width: '45%'}} },
								{ columnId: 'notes', styles: {tdHeader: {width: '35%'}} },
							],
						}}
						styles={{
							divMain: {marginBottom: '5px'},
							table: {width: '100%'},
							trHeader: {height: '43px'}
						}}
					/>
				</div>
			</div>
		)
	}
}

export const validateOrganization = (instance, fieldOrganization) => {
	let resource = getCurrentResource().pages.plain.components.DivOrganization;
	if( ! instance.id  ) { // New instance
		let orgType = fieldOrganization.value.orgType.value;
		if( ! orgType )
			return resource.msgEmptyFieldOrgType;
		let code = fieldOrganization.value.code.value;
		if( orgType == 'leg' ) {
			if( ! code )
				return resource.msgEmptyEDRPOU;
			if( code.length != 8 && code.length != 9 )
				return resource.msgInvalidEDRPOULength;
		} else if( orgType == 'ind' ) {
			if( ! code )
				return resource.msgEmptyIPN;
			if( code.length != 10 )
				return resource.msgInvalidIPNLength;
		}
	}
	return null;	
}

export default DivOrganization;
